"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItem = NotificationItem;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const localized_path_1 = require("@src/shared/localized-path");
const slug_1 = __importDefault(require("@src/shared/slug"));
const types_1 = require("@src/types");
const NotificationImageOrIcon_1 = require("@src/components/modules/global/NotificationImageOrIcon");
const get_cdn_image_url_for_account_type_1 = require("@src/helpers/get-cdn-image-url-for-account-type");
const NotificationItem_style_1 = require("./NotificationItem.style");
function getNotificationLink(notificationType, context) {
    let page = '/';
    const locale = typeof window !== 'undefined' ? (0, localized_path_1.getLanguageFromPathname)(window.location.pathname) : 'sk';
    switch (notificationType) {
        case types_1.NotificationType.COMPANY_SUBSCRIPTION_NOTIFICATION: {
            const c = context;
            page = `/ponuka/${new slug_1.default({ text: c.offerTitle, suffix: c.offerId }).result}`;
            break;
        }
        case types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION: {
            const c = context;
            page = `/ponuka/${new slug_1.default({ text: c.offerTitle, suffix: c.offerId }).result}`;
            break;
        }
        case types_1.NotificationType.NEW_COMPANY_SUBSCRIBER_NOTIFICATION: {
            const c = context;
            page = `/firma/${c.companyUrl}`;
            break;
        }
        case types_1.NotificationType.HIRING_PROCESS_RESULT_NOTIFICATION: {
            page = `/ucet`;
            break;
        }
        case types_1.NotificationType.HIRING_PROCESS_CLOSED_NOTIFICATION: {
            const c = context;
            page = `/admin/vyberovy-proces/${c.offerId}`;
            break;
        }
        case types_1.NotificationType.NEW_OFFER_APPLICATION_NOTIFICATION: {
            const c = context;
            page = `/admin/vyberovy-proces/${c.offerId}`;
            break;
        }
        case types_1.NotificationType.CREDITS_EXPIRATION_NOTIFICATION: {
            page = '/admin/kredity';
            break;
        }
        case types_1.NotificationType.NEW_CANDIDATE_INTERVIEW_NOTIFICATION: {
            page = `/ucet`;
            break;
        }
        case types_1.NotificationType.COMPANY_VIEWED_RESUME_NOTIFICATION: {
            page = '/ucet';
            break;
        }
        case types_1.NotificationType.CREDITS_PAID_NOTIFICATION: {
            page = '/admin/platby';
            break;
        }
        case types_1.NotificationType.COMPANY_OFFER_DEADLINE_NOTIFICATION: {
            page = '/admin';
            break;
        }
        default:
            page = '/';
    }
    return (0, localized_path_1.getLocalizedPath)(page, locale);
}
function getNotificationContent(intl, notificationTypeId, context) {
    switch (notificationTypeId) {
        case types_1.NotificationType.COMPANY_SUBSCRIPTION_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.new_company_offer.menu' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) });
        case types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.new_subscription_offer' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) });
        case types_1.NotificationType.NEW_COMPANY_SUBSCRIBER_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.new_company_subscriber.content' });
        case types_1.NotificationType.HIRING_PROCESS_RESULT_NOTIFICATION: {
            const { stage, companyName, offerTitle, offerId } = context;
            const result = stage === types_1.EOfferApplicationStage.hired
                ? intl.formatMessage({ id: 'global.notification.hired' })
                : intl.formatMessage({ id: 'global.notification.rejected' });
            const contextWithTranslatedStage = {
                companyName,
                offerTitle,
                stage: result,
                offerId,
            };
            return intl.formatMessage({ id: 'global.notification.hiring_process_result' }, { ...contextWithTranslatedStage, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) });
        }
        case types_1.NotificationType.HIRING_PROCESS_CLOSED_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.hiring_process_closed' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) });
        case types_1.NotificationType.NEW_OFFER_APPLICATION_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.new_offer_application.menu' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) });
        case types_1.NotificationType.CREDITS_EXPIRATION_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.credits_expiration.content' });
        case types_1.NotificationType.NEW_CANDIDATE_INTERVIEW_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.candidate_progress.interview' }, {
                ...context,
                strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
            });
        case types_1.NotificationType.COMPANY_VIEWED_RESUME_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.candidate_progress.viewed' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) });
        case types_1.NotificationType.CREDITS_PAID_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.paid_credits' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) });
        case types_1.NotificationType.COMPANY_OFFER_DEADLINE_NOTIFICATION:
            return intl.formatMessage({ id: 'global.notification.offer_deadline.menu' }, {
                ...context,
                strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
            });
        default:
            return '';
    }
}
function NotificationItem({ notification, onClick }) {
    const intl = (0, react_intl_1.useIntl)();
    const now = new Date();
    const context = notification.context ? JSON.parse(notification.context) : {};
    const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[notification.notification_type_id];
    const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(notification.image, notificationSenderAccountType, 'c_scale,w_30');
    return ((0, jsx_runtime_1.jsx)("span", { onClick: onClick, children: (0, jsx_runtime_1.jsxs)(NotificationItem_style_1.NotificationItemWrapper, { to: getNotificationLink(notification.notification_type_id, context), isNew: !notification.clicked_at, children: [(0, jsx_runtime_1.jsx)(NotificationItem_style_1.NotificationImageOrIconWrapper, { children: (0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: notification.notification_type_id, imageUrl: imageUrl, isNew: !notification.clicked_at }) }), (0, jsx_runtime_1.jsxs)(NotificationItem_style_1.ContentWrapper, { children: [(0, jsx_runtime_1.jsx)(NotificationItem_style_1.Content, { isNew: !notification.clicked_at, children: getNotificationContent(intl, notification.notification_type_id, context) }), (0, jsx_runtime_1.jsx)(elements_1.Timestamp, { now: now, date: new Date(notification.created_at) })] })] }) }));
}
